module.exports = __webpack_public_path__ + "img/lasource-22.739d63c4.jpg";